import pillar1 from "@/assets/icons/pillar-1.svg";
import pillar2 from "@/assets/icons/pillar-2.svg";
import pillar3 from "@/assets/icons/pillar-3.svg";
import pillar4 from "@/assets/icons/pillar-4.svg";
import pillar5 from "@/assets/icons/pillar-5.svg";

export const EDUCATION_PAGE = "homepage";
export const EDUCATION_PAGE1 = "header";
export const SCHOOL_page = "aedschoolpage";

export const BATEEN_WORLD = "eZyME5wL2EeqzVPKMuRopg";
export const AL_AIN_BRITISH = "dvWA_K3XZUGM2ig2Ft-D1g";
export const YAS_AMERICAN = "N54YcQpwPE6lIiZofnOShQ";
export const YASMINA_BRITISH = "cAMvf2_5fU6wA7iwDD1PlQ";
export const MAMOURA_BRITISH = "qyW1tSu_B063dKd0x-Alng";
export const MUNA_BRITISH = "BAgalXzfy0yggtJ1k505nQ";
export const VIRGINIA_INTERNATIONAL = "JrV85EpiBU2_HlM4DubeAg";
export const CRANLEIGH_ABU_DHABI = "J5k0-sBi9Ue7MapwWpbfug";
export const KENT_DUBAI = "bN8NUAUOXkutptFfCzKafA";
export const CRANLEIGH_BAHRAIN = "wdCrzjTjfUaJJ6Uv-V_z8A";
export const PEARL_BRITISH = "mhIVmozFhkyaQHgmX8G61w";
export const NOYA_BRITISH = "aIxKFqHLZUidTlYACDtzuw";
export const Al_SHOHUB_SCHOOL = "Qt2ZCqnf3EayDKc_a2M5rw";

export const BRITISH_CURRICULUM = "YNVSYJrmdEi0q5U4IBx7Rw";
export const AMERICAN_CURRICULUM = "BZA3RJ-Q9EeK9uXcnNyl6A";
export const IB_CURRICULUM = "_29roPPHx0aS9IfuJCamUQ";

// export const BRITISH_CURRICULUM = "british";
// export const AMERICAN_CURRICULUM = "american";
// export const IB_CURRICULUM = "ib";

export const PRODUCT_COMPARISON = "KVdo0xpzQk6DNXZOzhAQqA";
export const ABOUT_PAGE = "-LcBbt5HZEiJrLL7OHhtdw";
export const CAREERS = "r1kgtCeCGU6BaJpBQK23ZQ";
export const OUR_PARENTS = "n3MGiJyOpkipwp-HC8ZXzA";
export const INTERNATIONAL_CONNECTION = "Edt9rr52D0WlnlENfO3uHg";
export const SCHOLARSHIP = "3HPVtK8K70aeB0NP9fWy1A";
export const WHY_ALDAR = "glkfZzO2zUyf9PyCkRm2bQ";
export const ALUMINI = "fTabiHdb3EOMWfg19-v4gg";
export const PRIVACY_POLICY = "3stz2lJ1EUq5-EJxPWP-sg";
export const TERMS_OF_USE = "4MFNcBgSe0WSHOjzNgYcSw";
export const PAGE_NOT_FOUND = "4YqBCrpaZkq1mdXL8VNtHw";
export const STUDENT_LIFE = "qaXn80rcFke4L0ad9Q3WhQ";
export const CONTACT_US = "JmOpi3_azECmt4ZvGtYLzQ";
export const ARTICLE = "GSw-8sRXNkiKBTEXT5D81w";
export const ARTICLE_DETAILS1 = "zoobyGIsPUe3RV-WB25G3w";
export const ARTICLE_DETAILS2 = "8nvGcj4UREKJaKrx6CTgaw";
export const ARTICLE_DETAILS3 = "9NV-HPtyLECvfX_eMCd1xw";
export const ARTICLE_DETAILS4 = "Epmp_HHFu0KyfYSZ8yr-6A";
export const ARTICLE_DETAILS5 = "hau39-bv20qKOwmVVSEcSQ";
export const ARTICLE_DETAILS6 = "RYjhQsuCFUSJGK-Q0nsMYA";
export const THANK_YOU = "IoChN4OfY0KzAIgQ2gQYOg";
export const PURCHASES = "JakngmfIPk-_C8p8MpOvqw";

export const FORMLABEL = "formlabels";
export const PARENT_CONATCTUS = "contact-us";
export const SETTINGS = "settings";
export const PROFILE_CHANGE_PASSWORD = "change-password";
export const CREATE_SERVICE_REQUEST = "create-service-request";
export const PARENT_404PAGE = "404";
export const PARENT_PROFILE_ID = "005Ec00000B2QmTIAV";
export const PARENT_PROFILE_NAME = "profile-page";
export const OFFER_ACCEPTANCE = "accept-offer";
export const VIEW_APPLICATION = "view-application";

export const SCHOOLID = "001Ec00000XY0AnIAL";


export const verify_captcha_message = "Please verify the Captcha";

export const REQUIRED = "Required";
export const INVALID_EMAIL_ADDRESS = "Invalid email address";
export const INVALID_EMAIL = "Invalid email";
export const SPECIAL_CHAR_NOT_ALLOWED = "Special characters and numbers are not allowed.";
export const SPECIAL_CHARS = "Special characters are not allowed.";
export const INVALID_PHONE_NUM = "Invalid phone number";
export const TOO_SHORT = "Too Short!";
export const TOO_LONG = "Too Long!";
export const THANK_YOU_REDIRECTION = "You cannot redirect to the thank you page without a completed form submission.";


// Onboarding Portal
export const PARENT_HEADER_AND_FOOTER = "menu";
export const PARENT_HEADER_AND_FOOTER_LOGGED_OFF = "menu-new";
export const PARENT_DASHBOARD = "dashboard";
export const PARENT_PRIVACY_POLICY = "privacy";
export const PARENT_TERMS_AND_CONDITION = "termsandcondition";
export const PARENT_FORM_LABELS = "formlabels";
export const PARENT_LANGUAGE = "language";

export const DASHBOARD_SC = "dashboard"
export const THANKYOU = "thank-you"

export const FAQS = "faqs"
export const CMS_SIGNUP = "sign-up"
export const CMS_LOGIN = "sign-in"
export const CMS_FORGOT_PASSWORD = "forgot-password"
//export const CHANGE_PASSWORD = "change-password"
export const CHANGE_PASSWORD = "v2-change-password"
export const CMS_SET_PASSWORD = "set-password"
export const CMS_VERIFY_OTP = "otp"

export const UPDATE_STUDENT_PROFILE = `Student profile updated!`;

export const FILL_FORM_FIELD = `Please ensure all required fields are filled out before submitting!`;

export const STUDENT_FIRST_NAME_MIN = `Student first name must be at least 3 characters long`;
export const STUDENT_FIRST_NAME_MAX = `Student first name should be 50 characters long or less`;
export const STUDENT_FAMILY_NAME_MIN = `Student family name must be at least 3 characters long`;
export const STUDENT_FAMILY_NAME_MAX = `Student family name should be 50 characters long or less`;

export const FATHER_FIRST_NAME_MIN = `Father first name must be at least 3 characters long`;
export const FATHER_FIRST_NAME_MAX = `Father first name should be 50 characters long or less`;
export const FATHER_LAST_NAME_MIN = `Father last name must be at least 3 characters long`;
export const FATHER_LAST_NAME_MAX = `Father last name should be 50 characters long or less`;

export const MOTHER_FIRST_NAME_MIN = `Mother first name must be at least 3 characters long`;
export const MOTHER_FIRST_NAME_MAX = `Mother first name should be 50 characters long or less`;
export const MOTHER_LAST_NAME_MIN = `Mother last name must be at least 3 characters long`;
export const MOTHER_LAST_NAME_MAX = `Mother last name should be 50 characters long or less`;

export const STUDENT_FIRST_NAME_REP = `Student's family name appears to have excessive repetition`;
export const STUDENT_LAST_NAME_REP = `Student's family name appears to have excessive repetition`;

export const FATHER_FIRST_NAME_REP = `Father's first name appears to have excessive repetition`;
export const FATHER_LAST_NAME_REP = `Father's last name appears to have excessive repetition`;

export const MOTHER_FIRST_NAME_REP = `Mother's first name appears to have excessive repetition`;
export const MOTHER_LAST_NAME_REP = `Mother's last name appears to have excessive repetition`;


export const CHILD_ATTENDER = `Child attending name appears to have excessive repetition`;

export const INVOICE_NAME_VALIDATION = `Person name must contain only letters and spaces. Special characters,numbers are not allowed`;

export const INVOICE_ACCOUNT_CODE = `Invoice account code must be at least 3 characters long`;

export const FAILED_TO_SUBMIT_DATA = `Submission failed. Please try again.`;
export const NETWORK_ERROR = `Network error. Please try again.`;
